module.exports = __webpack_public_path__ + "static/img/car_mobile_renting.9.08ad49ba.png";